const mutations = {
  setSaleList(state, data) {
    state.saleList = data;
  },
  setSale(state, data) {
    state.sale = data;
    if (data.paymentMode) {
      state.sale.paymentModeId = data.paymentMode.paymentModeId;
    }
  },
  resetSale(state) {
    state.sale = {
      date: new Date(),
      createdBy: "",
      userId: "",
      discount: 0,
      products: [],
      paymentModeId: "",
      paymentNote: "",
      amountPaid: 0,
      total: 0,
      roundOff: 0
    };
  },
  setDefaultPaymentMode(state, data) {
    state.sale.paymentModeId = data;
    state.defaultPaymentModeId = data;
  },
  setSaleTransactions(state, data) {
    state.saleTransactions = data;
  },
  resetSaleTransaction(state) {
    state.saleTransaction = {
      amount: 0,
      date: new Date(),
      paymentModeId: ""
    };
  },
  // using while adding credit notes against sale
  setSaleUser(state, user) {
    state.sale.user = user;
  },
  setReceiptData(state, data) {
    state.receiptData = data;
  },
  setSaleTotal(state, total) {
    state.sale.total = total;
  },
  setSaleRoundOff(state, roundOff) {
    state.sale.roundOff = roundOff;
  }
};

export default mutations;
